import { Component, OnInit, ViewChild, inject } from "@angular/core";
import { Command, CommandBarComponent, LabelCommand } from "@tylertech/commands-module";
import { DIALOG_DATA, DialogRef, ForgeScaffoldModule, ForgeToolbarModule } from "@tylertech/forge-angular";
import { ImageCroppedEvent, ImageCropperComponent } from "ngx-image-cropper";

@Component({
    selector: "metadata-photo-crop-dialog",
    templateUrl: "./metadataPhotoCropDialog.tmpl.html",
    imports: [
        ForgeScaffoldModule,
        ImageCropperComponent,
        ForgeToolbarModule,
        CommandBarComponent,
    ]
})
export class MetadataPhotoCropDialogComponent implements OnInit
{
    data = inject<IDialogData>(DIALOG_DATA);
    private _dialogRef = inject(DialogRef);

    @ViewChild("imageCropper") imageCropper: ImageCropperComponent;

    commands: Command[];
    croppedImage: string;

    ngOnInit(): void
    {
        const self = this;
        this.commands = [
            new LabelCommand({
                label: "Cancel",
                action: () => self.close(),
            }),
            new LabelCommand({
                label: "Done",
                action: () => self.close(true),
            }),
        ];
    }

    close(save = false): void
    {
        this._dialogRef.close(save ? this.croppedImage : null);
    }

    imageCropped(event: ImageCroppedEvent): void
    {
        this.croppedImage = event.base64;
    }
}

export interface IDialogData
{
    photo: string;
}
